import apiRequest from 'utils/api/apiRequest';

const BASE = process.env.REACT_APP_LOANFREEZE_API_URL;
const APPLICATION_URL = `${BASE}/Management`;

export const api = {
  getMyApplications: () => apiRequest(`${APPLICATION_URL}/getMyApplications`),
  getApplication: guid => apiRequest(`${APPLICATION_URL}/GetApplication/${guid}`),
  getApprovedApplications: onlyLender => {
    const dt = {
      onlyApplicationsWhereMyCompanyIsLender: onlyLender,
      includeAcknowledgedApplications: true
    };
    return apiRequest(`${APPLICATION_URL}/GetApprovedApplications`, { method: 'post', data: dt });
  },
  declineApplication: data =>
    apiRequest(`${APPLICATION_URL}/DeclineApplication`, { method: 'post', data }),
  approveApplication: data =>
    apiRequest(`${APPLICATION_URL}/ApproveApplication`, { method: 'post', data }),
  putApplicationOnHold: data =>
    apiRequest(`${APPLICATION_URL}/PutApplicationOnHold`, { method: 'post', data }),
  deleteApplication: guid =>
    apiRequest(`${APPLICATION_URL}/DeleteApplication/${guid}`, { method: 'post' })
};

if (process.env.NODE_ENV === 'development') {
  window.api = api;
}
